// 参考: https://ics.media/entry/220901/
export default class {
  constructor(el) {
    this.dom = {el : el};
    this.dom.summary = this.dom.el.querySelector('summary');
    this.dom.panel = this.dom.el.querySelector('summary + *');

    console.log(this.dom.panel);

    this.RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
    this.IS_OPENED_CLASS = "is-active"; // アイコン操作用のクラス名

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.init();
  }

  init() {

    this.dom.summary.addEventListener('click', evt => {
      evt.preventDefault();

      // 連打防止用 アニメーション中だったらクリックイベントを受け付けない
      if (this.dom.el.dataset.animStatus === this.RUNNING_VALUE) {
        return;
      }

      if (this.dom.el.open) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  open() {
    const keyframes = (panel) => [ // 関数にしないとSafariでうまく動かない（panelの高さがとれない？）
      {
        height: 0,
      }, {
        //height: `${this.dom.panel.offsetHeight}px`,
        height: `${panel.offsetHeight}px`,
      }
    ];

    const timing = {
      //duration: 400,
      //easing: 'ease-out',
      duration: 700,
      easing: 'cubic-bezier(0.7, 0, 0.1, 1)',
    };

    this.dom.el.setAttribute('open', 'true');
    this.dom.el.classList.add(this.IS_OPENED_CLASS);
    const anim = this.dom.panel.animate(keyframes(this.dom.panel), timing);
    this.dom.el.dataset.animStatus = this.RUNNING_VALUE;

    anim.onfinish = () => {
      this.dom.el.dataset.animStatus = null;
    };
  }

  close() {
    const keyframes = (panel) => [ // 関数にしないとSafariでうまく動かない（panelの高さがとれない？）
      {
        height: `${panel.offsetHeight}px`, // height: "auto"だとうまく計算されないため要素の高さを指定する
      }, {
        height: 0,
      }
    ];

    const timing = {
      //duration: 400,
      //easing: 'ease-out',
      duration: 1000,
      easing: 'cubic-bezier(0.7, 0, 0.1, 1)',
    }

    this.dom.el.classList.remove(this.IS_OPENED_CLASS);
    const anim = this.dom.panel.animate(keyframes(this.dom.panel), timing);
    this.dom.el.dataset.animStatus = this.RUNNING_VALUE;

    anim.onfinish = () => {
      this.dom.el.removeAttribute('open');
      this.dom.el.dataset.animStatus = null;
    };
  }
}
